import { Image, Tab, Tabs } from "@nextui-org/react";
import React, { useContext, useEffect, useState } from "react";
import DetailsActions from "../DetailsActions";
import { Link, useLocation, useParams } from "react-router-dom";
import useSettings from "hooks/useSettings";
import { SettingsContext } from "Context/SettingsContext";

const TasklistTabs = () => {
  const { frondId } = useParams();
  const { pathname } = useLocation();
  const [activeLink, setActiveLink] = useState(pathname);
  useEffect(() => {
    setActiveLink(pathname.split("/")[3]);
  }, [pathname, activeLink]);

  const { loadSettings } = useSettings({ projectId: frondId });
  const { frondSettings } = useContext(SettingsContext);
  return (
    <div className="tabs flex items-center gap-x-2.5 gap-y-5 justify-between xl:flex-nowrap flex-wrap mb-[15px] xl:w-auto lg:w-3/4 w-full">
      <Tabs
        selectedKey={activeLink}
        aria-label="Scrapbook Tabs"
        radius="full"
        classNames={{
          tabList:
            "bg-white border-1 border-solid border-grayBorder p-0 w-full phone:h-[36px]",
          tab: "py-[6px] xl:px-[30px] tasklist-tab h-[100%]",
          tabContent:
            "phone:text-base text-[12px] font-normal leading-[18.4px] text-textColor",
          base: "xl:w-auto w-full",
        }}
      >
        <Tab
          key="all"
          title="All"
          as={Link}
          to={`/frond/tasklist/all/${frondId}`}
        />
        <Tab
          key="pending"
          title={
            <span className="flex items-center gap-2">
              {/* <span className="w-2.5 h-2.5 rounded-full bg-blueTimeline"></span> */}
              Pending
            </span>
          }
          as={Link}
          to={`/frond/tasklist/pending/${frondId}`}
        />
        <Tab
          key="in-progress"
          title={
            <span className="flex items-center gap-2">
              {/* <span className="w-2.5 h-2.5 rounded-full bg-redTimeline"></span> */}
              In Progress
            </span>
          }
          as={Link}
          to={`/frond/tasklist/in-progress/${frondId}`}
        />
        <Tab
          key="completed"
          title={
            <span className="flex items-center gap-2">
              {/* <span className="w-2.5 h-2.5 rounded-full bg-greenTimeline"></span> */}
              Completed
            </span>
          }
          as={Link}
          to={`/frond/tasklist/completed/${frondId}`}
        />
        <Tab
          key="archived"
          title={
            <span className="flex items-center gap-2">
              {/* <span className="w-2.5 h-2.5 rounded-full bg-pinkTimeline"></span> */}
              Archived
            </span>
          }
          as={Link}
          to={`/frond/tasklist/archived/${frondId}`}
        />
      </Tabs>
    </div>
  );
};

export default TasklistTabs;
